
import { MigrationTransformBase } from './MigrationTransformBase';
import { IValueTransformOptions } from './models/TValueTransform';
import { deepMergeObjects } from '../../utils/object';

export class ValueTransform extends MigrationTransformBase<IValueTransformOptions> {
	get type(): string {
		return 'value';
	}
	up(seed: object): object {
		const { key, parentJsPath, oldValue, newValue } = this.options;
		return this.valueTransform(seed, key, oldValue, newValue, parentJsPath);
	}
	down(seed: object): object {
		const { key, parentJsPath, oldValue, newValue } = this.options;
		return this.valueTransform(seed, key, newValue, oldValue, parentJsPath);
	}
	valueTransform(seed: object, key: string, oldValue: any, newValue: any, parentJsPath?: string) {
		const clone = deepMergeObjects({}, seed);
		const parentInstances = this.getParentInstances(clone, parentJsPath);
		for (const parentInstance of parentInstances) {
			if (parentInstance[key] === oldValue) {
				parentInstance[key] = newValue;
			}
		}
		return clone;
	}
}